import { Map } from 'mapbox-gl';
import { mapColorPalette } from "../../../../../constants/Map";
import { ZoomLevel } from "../../../../../store/publicWaterSystem";
import { ICountyPublicWaterSystemResult } from '../../../../../types';
import { handleCountyZoom } from '../handlers';

export const updateCountyStyles = (
  mapRef: React.RefObject<Map>,
  countyViolations: ICountyPublicWaterSystemResult[] | null,
  countyViolationsRef: React.MutableRefObject<ICountyPublicWaterSystemResult[] | null>,
  zoomLevel: ZoomLevel | string,
  prevSelectedCode: React.MutableRefObject<any>
): void => {
  if (!Array.isArray(countyViolations) || zoomLevel !== ZoomLevel.COUNTY) {
    return;
  }

  countyViolationsRef.current = countyViolations;

  const applyStyles = () => {
    if (!mapRef.current) return;

    const sortedCounties = [...countyViolations].sort((a, b) => b.violations - a.violations);
    
    const countyColorMapping = sortedCounties.reduce<Record<string, string>>((acc, county, index) => {
      if (!county?.county_name) return acc;
      
      if (county.violations === 0) {
        acc[county.county_name] = '#FFFFFF';
        return acc;
      }

      const countiesPerGroup = Math.ceil(sortedCounties.filter(c => c.violations > 0).length / mapColorPalette.length);
      const colorIndex = Math.min(
        Math.floor(index / countiesPerGroup),
        mapColorPalette.length - 1
      );
      
      acc[county.county_name] = mapColorPalette[colorIndex];
      return acc;
    }, {});

    const colorEntries = Object.entries(countyColorMapping).filter(entry => entry[0] && entry[1]);
    if (colorEntries.length === 0) {
      mapRef.current.setPaintProperty('main', 'fill-color', '#FFFFFF');
      return;
    }

    const matchExpression: mapboxgl.Expression = [
      'match',
      ['get', 'name'],
      ...colorEntries.map(([county, color]) => [county, color]).flat(),
      '#FFFFFF'
    ] as mapboxgl.Expression;

    mapRef.current.setPaintProperty('main', 'fill-color', matchExpression);
  };
  if (mapRef.current?.isStyleLoaded()) {
    applyStyles();
    return;
  }else{
  handleCountyZoom(mapRef.current, prevSelectedCode, countyViolationsRef);
  }

  mapRef.current?.once('style.load', () => {
    applyStyles();
  });
};
